// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y42VefU7FKP6wOZgdsZU {
    padding: 2rem;
    background: white;
}

.Ex08BxuTYmUSxG50CGHb {
    width: 50%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 1rem;
    filter: grayscale(100%);
}

.x2JY1fsvjoHWrW7CaaJS {
    width: 60%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4rem;
}

.xG_5ahFfYXczIfkr0dZy {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 1.125rem;
    margin-bottom: 0.5rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

@media screen and (max-width: 768px) {
    .x2JY1fsvjoHWrW7CaaJS {
        flex-direction: column;
        width: 100%;
        gap: 2rem;
    }

    .Ex08BxuTYmUSxG50CGHb {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Solution/Solution.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI;QACI,sBAAsB;QACtB,WAAW;QACX,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".container {\n    padding: 2rem;\n    background: white;\n}\n\n.team {\n    width: 50%;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 1rem;\n    filter: grayscale(100%);\n}\n\n.row {\n    width: 60%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 4rem;\n}\n\n.description {\n    color: rgba(0, 0, 0, 0.50);\n    font-family: Inter, sans-serif;\n    font-size: 1.125rem;\n    margin-bottom: 0.5rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n@media screen and (max-width: 768px) {\n    .row {\n        flex-direction: column;\n        width: 100%;\n        gap: 2rem;\n    }\n\n    .team {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Y42VefU7FKP6wOZgdsZU`,
	"team": `Ex08BxuTYmUSxG50CGHb`,
	"row": `x2JY1fsvjoHWrW7CaaJS`,
	"description": `xG_5ahFfYXczIfkr0dZy`
};
export default ___CSS_LOADER_EXPORT___;
